<template>
  <div></div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  async created() {
    await this.getLoansByOngoing()
  },
  methods: {
    ...mapActions('loan', ['getLoansByOngoing']),
  },
}
</script>
